import React from "react";
import styles from "./PeopleUI.module.css";

// "+ Add contact info" opens the edit form; read-only viewers get a muted note instead.
export default function EmptyContact({ employee, onAddContactInfo }) {
  if (!onAddContactInfo) {
    return <span className={styles.emptyContactMuted}>No contact info</span>;
  }

  // Cards and table rows are themselves clickable, so this is a span acting as a button rather than a nested <button>.
  return (
    <span
      role="button"
      tabIndex={0}
      className={styles.emptyContactLink}
      onClick={(e) => {
        e.stopPropagation();
        onAddContactInfo(employee);
      }}
      onKeyDown={(e) => {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        e.stopPropagation();
        onAddContactInfo(employee);
      }}
    >
      + Add contact info
    </span>
  );
}
